import { FC } from 'react';
// components
import ProductIngredient from 'components/main/ProductIngredient/Edit';

const EditProductIngredient: FC = () => <ProductIngredient />;

export default EditProductIngredient;
